import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import App from './App'
import { bindVisibility, musicEnabled, startMusic } from './audio/music'
import { unlock } from './audio/sfx'
import { useGame } from './store/gameStore'
import './styles/global.css'
import './styles/game.css'

// เบราว์เซอร์ยอมให้สร้าง AudioContext ได้หลังผู้ใช้มี interaction แรกเท่านั้น
// จึงต้องรอ interaction ก่อนแล้วค่อยเริ่มเพลง
for (const ev of ['pointerdown', 'keydown', 'touchstart'] as const) {
  window.addEventListener(
    ev,
    () => {
      unlock()
      if (musicEnabled()) startMusic()
    },
    { once: false, passive: true },
  )
}
bindVisibility()

// เปิดสโตร์ให้เข้าถึงจากคอนโซลตอนพัฒนา ใช้รันเกมบอทล้วนทดสอบเอนจิน
if (import.meta.env.DEV) {
  ;(window as unknown as { millo: typeof useGame }).millo = useGame
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
